// extracted by mini-css-extract-plugin
export var blue = "_2c-f";
export var brand = "_2c-b";
export var darkGrey = "_2c-e";
export var disabled = "_2c-4";
export var disabledSubtle = "_2c-5";
export var error = "_2c-6";
export var green = "_2c-g";
export var grey = "_2c-d";
export var icon = "_2c-0";
export var inherit = "_2c-a";
export var lightGrey = "_2c-c";
export var orange = "_2c-i";
export var pink = "_2c-k";
export var primary = "_2c-1";
export var purple = "_2c-l";
export var red = "_2c-j";
export var secondary = "_2c-2";
export var success = "_2c-9";
export var tertiary = "_2c-3";
export var warning = "_2c-7";
export var warningSecondary = "_2c-8";
export var white = "_2c-m";
export var yellow = "_2c-h";